export default "__VITE_ASSET__DywlZ9jc__"